export const getFactionImagePath = (factionId) => {
  return `/img/factions/${factionId}.jpg`;
}